<template>
  <div class="page background-main">
    <!-- <AppBackgroundCanvas /> -->
    <div class="page_stage_shell">
      <div class="page_stage">
        <div class="app_body">
          <div class="main_container">
            <template v-if="isDeviceSelected">
              <Root></Root>
            </template>
            <template v-if="!isDeviceSelected">
              <empty v-if="isShowEmpty" />
              <selector v-else />
            </template>
            <cdialog />
            <loading />
            <feedback />
            <setting />

            <app_update_notice />
            <service_update_notice />
            <Pair24g />
            <Firmware_upgrade />
            <dev_brand_switcher />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppBackgroundCanvas from '@/components/background/AppBackgroundCanvas.vue'
import cdialog from '@/components/cdialog/cdialog.vue'
import loading from '@/components/loading/loading.vue'
import feedback from './components/feedback/feedback.vue'
import empty from './components/empty/empty.vue'
import selector from './components/selector/selector.vue'
import setting from './components/setting/setting.vue'
import Pair24g from './components/pair_24g/pair_24g.vue'
import { DeviceManager } from './service/device'
import { DevicePid } from './define/define'

import service_update_notice from '@/components/service_update/service_update_notice.vue'
import app_update_notice from './components/app_update/app_update_notice.vue'
import { isElectron } from '@libs/utils/envUtils'
import Root from './components/main/root.vue'
import Firmware_upgrade from './components/firmware_upgrade/firmware_upgrade.vue'
import dev_brand_switcher from '@/components/dev/dev_brand_switcher.vue'

import { trackWebActivity } from '@/utils/appEffect'

const isDeviceSelected = computed(() => DeviceManager.instance.state.currentPid != DevicePid.None)
const isShowEmpty = computed(() => {
  return isElectron() && DeviceManager.instance.state.webDeviceList.concat(DeviceManager.instance.state.deviceList).length == 0
})

// 网页驱动增加日活, 要求当前使用的语言是中文, 进行统计
trackWebActivity()

if (process.env.NODE_ENV === 'development' && typeof electronAPI !== 'undefined') {
  electronAPI.openDev()
}
</script>

<style scoped lang="less">
.page {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  font-family: var(--font-main);
}

.page_stage_shell {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  flex-shrink: 0;
  overflow: hidden;
  z-index: 1;

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    filter: blur(120px);
    opacity: 0.8;
  }

  &::before {
    width: 760px;
    height: 760px;
    top: -300px;
    right: -140px;
    background: radial-gradient(circle, rgba(var(--color-brand-1-rgb), 0.22) 0%, rgba(var(--color-brand-1-rgb), 0) 72%);
  }

  &::after {
    width: 620px;
    height: 620px;
    left: -140px;
    bottom: -180px;
    background: radial-gradient(circle, rgba(var(--color-brand-2-rgb), 0.24) 0%, rgba(var(--color-brand-2-rgb), 0) 72%);
  }
}

.page_stage {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 8px;
  backface-visibility: hidden;
  // border-radius: 20px;
  background: var(--shell-surface);
  border: 1px solid rgba(var(--color-brand-1-rgb), 0.06);
  overflow: hidden;
}

.app_body {
  flex: 1;
  min-height: 0;
  display: flex;
  border-radius: 0;
  overflow: hidden;
}

.main_container {
  flex: 1;
  display: flex;
  position: relative;
  min-height: 0;
}
</style>
